//封装操作sessionStorage本地存储的方法   模块化的文件


// nodejs  基础



var sessionStorageObj = {
    set(key, value) {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (e) {
            console.error("保存缓存出错，key=" + key, value, e);
            return null;
        }
    },
    get(key) {
        try {
            return JSON.parse(sessionStorage.getItem(key));
        }
        catch (e) {
            console.error("读取缓存出错，key=" + key, e);
            return null;
        }
    }, remove(key) {
        try {
            sessionStorage.removeItem(key);
        }
        catch (e) {
            console.error("删除缓存出错，key=" + key, e);
            return null;
        }
    }

}

export default sessionStorageObj;


